import React from 'react';

import { PatientParams } from '../../../libs/summary';

interface SummaryCellProps {
  label: React.ReactNode;
  value: React.ReactNode;
  status?: React.ReactNode;
  unit?: string;
}

export const SummaryCell: React.FC<SummaryCellProps> = ({
  label,
  value,
  status,
  unit
}) => {
  // Be smart about number output
  let output = value;
  if (!value) {
    output = 'N/A';
  } else if (!isNaN(value as any)) {
    if (parseInt(value as string) !== value) {
      output = (value as number).toFixed(2);
    }
  }
  return (
    <div className="px-0-important text-center mb-8">
      <p className="text-sans-sm font-bold">{label}</p>
      <h2 className="mt-0 mb-0">
        {status}
        {output}
      </h2>
      {unit ? <span className="text-sans-sm">{unit}</span> : null}
    </div>
  );
};

export interface AppSummaryInstanceProps<
  T extends PatientParams = PatientParams
> {
  params?: T;
}
